<template>
	<div>
		<LiveSportCount v-if="$route.query.onLive" />
		<div v-if="eventNotfound" class="alert alert-info">
			{{ t.error.notfound_fixture }}
		</div>

		<div class="white-box match-e" v-if="events">
			<table class="table table-padded">
				<tbody>
				<tr v-for="e in events" v-if="events">
					<template v-if="e.type === 'competition'">
					<td class="competition_head" colspan="5">
						<strong> {{e.sport.name}} » {{e.region.name}} » {{ e.name }} </strong>
						<!--
						<div id="toggles" class="pull-left pr-2" v-tooltip="'Disable it'">
							<input type="checkbox" class="ios-toggle" v-on:change="actionCompetitionStatus(e.id)" :id="'cou_'+e.id" v-model="comp.isActive" :name="'cou_'+e.id" value="1">
							<label :for="'cou_'+e.id" class="checkbox-label"></label>
						</div> -->
					</td>
					<td class="competition_head">
						<div style="width: 250px; float: right">
							<CompetitionTemplateSelect :id="e.id" :classes="classes"/>
						</div>
					</td>
					</template>
					<template v-if="e.type === 'event'">
						<td width="30">
								<div id="toggles" class="p-2" v-tooltip="'Book/Unbook for Live Fixture'">
									<input type="checkbox" class="ios-toggle" v-on:change="changeStatus(e.matchId, e.isDisabled, e.template)" :id="'ou_'+e.matchId" v-model="e.isDisabled" :name="'ou_'+e.matchId" value="1">
									<label :for="'ou_'+e.matchId" class="checkbox-label"></label>
								</div>
							</td>
							<td width="140" style="word-wrap: break-word;">
								<strong>{{ e.resultName }} {{ periodTimer(e) }}</strong>
							</td>
							<td width="70" class="text-center px-1">
								<span class="smaller lighter">
									{{ e.startDate | moment('MM.DD.YY HH:mm', session.timezone) }}
								</span>
							</td>
							<td class="text-left">
								<router-link :to="{params: {id: e.matchId}, query: $route.query }">
									{{ e.competitor.oneName | slimiter(25) }} VS {{ e.competitor.twoName | slimiter(25) }}
								</router-link> 
							</td>
							<td width="150" colspan="2">
								<select style="width: 150px" name="x" class="form-control pull-right" v-model="e.template">
								<option v-for="c in classes" :value="c.id">{{ c.name }}</option>
								</select>
							</td>
					</template>
				</tr>
				</tbody>
			</table>
		</div>


		
	</div>
</template>

<script>
    import Paginate from 'vuejs-paginate'
    import ContentPlaceholder from 'vue-content-placeholder'
    import Periods from '@/components/stats/match/periods'
    import Events from '@/components/stats/match/events'

    import mainOdds from '@/components/stats/odds/mainOdds'
    import underOverOdds from '@/components/stats/odds/underOverOdds'
    import handicap from '@/components/stats/odds/handicap'
    import winOdds from '@/components/stats/odds/winOdds'
    import matchForm from '@/components/stats/match/matchForm.vue'
    import odd from '@/components/stats/odds/odd';
    import scoreboard from '@/components/stats/widget/scoreboard'
    import matchDetail from '@/components/stats/widget/matchDetail'
    import feed from '@/mixins/feed.js'
	import activityWidget from '@/components/user/widget/activityWidget'
	import CompetitionTemplateSelect from './widget/competitionTemplateSelect.vue'
	import LiveSportCount from './widget/liveSportCount.vue'

    export default {
        name: 'matches',
	      components: { activityWidget, ContentPlaceholder, Paginate, Periods, mainOdds, underOverOdds, handicap, winOdds, Events, matchForm, odd, scoreboard, matchDetail, CompetitionTemplateSelect, LiveSportCount },
        props: {
            filter: {}
        },
        data () {
            return {
                match: null,
                event: null,
                app: this.$root.app,
                session: window.session,
                loader: true,
                t: this.$root.t,
                events: [],
                eventNotfound: false,
	              loader: false,
                selectedEventDate: false,
                session: session,
                pagination: [],
                page: 1,
                classes: [],
                placeholderRows:  [
                    { height: '1rem',
                        boxes: [[0, '20%'], ['2%', '15%'], ['2%', '30%'], ['20%', '8%']]
                    },
                ]
            }
        },
        mixins: [feed],
        watch: {
            'filter' () {
				this.page = 1
				this.events = []
				this.fetchEvents(false);
                //this.fetchEvents();
            },
	        '$route.params.id' (e) {
                this.showMatchDetails (this.$route.params.id);
	        }
        },
	    mounted () {

			var th = this
			window.onscroll = function(ev) {
				if ((window.innerHeight + Math.round(window.scrollY)) >= document.body.offsetHeight) {
					// you're at the bottom of the page
					th.onWaypointLoadMore()
				}
			};

			this.fetchTemplates().then(response => {
                    this.classes = response.body.result
            })

			this.page = 1
            this.fetchEvents();

            if(this.$route.params.id)
                this.showMatchDetails (this.$route.params.id);

        },
	    methods: {
			periodTimer (m) {
				if(m.periodTimeLeft != 0){

					return m.periodTimeLeft;

				}else if(m.periodTime > 0){

					var min = (parseInt((m.periodTime / 60).toFixed(0)) + 1);

					if(m.resultName == "1st half" && m.periodTime >= 2700)
						return "45' +"+Math.abs(45 - min);

					if(m.resultName == "2nd half" && m.periodTime >= 5400)
						return "90' +"+Math.abs(90 - min);

					return (min > 0) ? min+"'" : '';
				}

				if(m.periodCounter > 0){
					const min = (m.roundCounter / 3600).toFixed(2);

					return (min > 0) ? min+"'" : '';
				}
				},
			onWaypointLoadMore () {
				this.page++
				console.log('ss')
				if (this.events.length > 1)
					this.fetchEvents(this.page)
			},
            closeMatch (){
                this.match = null;
                this.event = null;
                this.$router.push({ params: {id: null}, query: {} });
                this.$router.push({ query: this.filter });
            },
            setEvent(id){
                this.event = id;
            },
            saveMatchClass(c){
              this.$http.get(api+'api/v1/match/class/'+c.matchId+'/'+c.class).then(response => {
                // get body data

              }, response => {
                // error callback

              })
            },
            saveClass(c){
              this.$http.get(api+'api/v1/competition/class/'+c.competitionId+'/'+c.class).then(response => {
                // get body data

              }, response => {
                // error callback

              })
            },
            changeStatus (m, d, t) {
                this.$http.post(api+'api/v2/feedstation/book-match/'+m+'?template='+t, {
                    params: {data: d, match: m, template: t }
                }).then(response => {
                    // get body data

                }, response => {
                    // error callback

                })
            },
            onChangePage (page) {
                this.pagination.current = page;
                this.filter.page = page;
                this.$router.push({ params: {}, query: {} });
                this.$router.push({ query: this.filter });
            },
            fetchMatch () {
                this.$http.get(bsapi+'api/v1/fixture/match/'+this.event).then(response => {

                    this.match = response.body.match;
                }, response => {

                })
            },
            fetchEvents (p = 1) {
                this.loader = true;
                if(!p){
					this.events = [];
				}

                this.eventNotfound = false;
				if (this.filter.competition){
					this.filter.competition = this.filter.competition.join(',')
				}
				
                this.$http.get(bsapi+'api/v2/fixture/full?_='+(Math.floor(Date.now() / 1000))+'&full=1&page='+p+'&app='+this.session.owner, {
					params: this.filter
                }).then(response => {
                    // get body data

					this.compileList(response.body.result).forEach((v,i) => {
						this.events.push(v)
					})
                    this.pagination = response.body.pagination;
                    this.loader = false;
                    this.eventNotfound = false;

                }, response => {
                    // error callback
                    //this.eventNotfound = true;
                    this.loader = false;
                })
            },
            showMatchDetails (e) {
                this.event = e;
                this.fetchMatch()
                this.$refs.matchmodal.open()
            },
			compileList(Result) {
				//Result = Result.sort(this.compare)

				//console.log(Result)

				var VirtualList = [];
				var Sport = 0;
				var Competition = 0;
				var Region = 0;
				var TimePeriod = '';

				var TimeP = moment().format('YYYY-MM-DD');

				Result.forEach(e => {
					
					if(e.sport.id != Sport){
						VirtualList.push({
							type: 'sport',
							id: e.sport.id,
							alias: e.sport.alias,
							name: (e.sport.nameLn.name !== '') ? e.sport.nameLn.name : e.sport.name
						})
						Sport = e.sport.id;
					}

					if(e.region.id != Region){
						VirtualList.push({
							type: 'region',
							id: e.region.id,
							sport: e.sport.id,
							name: (e.region.nameLn.name !== '') ? e.region.nameLn.name : e.region.name,
							n: e.region.name,
							regionCode: "int",
							class1: " ",
							class2: " ",
							class3: " ",
						})
						Region = e.region.id;
					}

					if(e.competition.id != Competition){
					
						VirtualList.push({
							type: 'competition',
							name: (e.competition.nameLn.name !== '') ? e.competition.nameLn.name : e.competition.name,
							id: e.competition.id,
							sport: {
								sportId: e.sport.id,
								name: (e.sport.nameLn.name !== '') ? e.sport.nameLn.name : e.sport.name,
								alias: e.sport.alias
							},
							region: {
								n:  e.region.name,
								id: e.region.id,
								name: (e.region.nameLn.name !== '') ? e.region.nameLn.name : e.region.name,
							}
						})
						Competition = e.competition.id;
					}

					TimeP = moment(e.startedAt).format('YYYY-MM-DD');

					if(TimeP != TimePeriod){
						VirtualList.push({
							type: 'timeperiod',
							period: TimeP
						})

						TimePeriod = TimeP;
					}

					var Stat = {};
					var Score = {};

					if(e.stat !== '')
						Stat = JSON.parse(e.stat);

					if(e.stat !== '')
						Score = JSON.parse(e.data);

					if(e.providerId == 7){
						delete Stat["2nd half"];
					}
						

					VirtualList.push({
						type: 'event',
						name: e.home.name+ ' - '+e.away.name,
						sport: {
							sportId: e.sport.id,
							name: e.sport.name,
							alias: e.sport.alias
						},
						region: {
							name: e.region.name,
							id: e.region.id
						},
						competition: {
							id: e.competition.id,
							name: e.competition.name
						},
						competitor: {
							one: e.home.id,
							oneEid: e.home.eid,
							two: e.away.id,
							twoEid: e.away.eid,
							oneName: (e.home.nameLn.name !== '') ? e.home.nameLn.name : e.home.name,
							twoName: (e.away.nameLn.name !== '') ? e.away.nameLn.name : e.away.name,
						},
						id: e.id,
						rid: e.radarId,
						matchId: e.id,
						extendedId: e.extendedId,
						minBetLimit: e.minBetLimit,
						marketCount: e.marketCount,
						betCount: e.betCount,
						isActive: e.isLive,
						isSuspended: e.isSuspended,
						isDisabled: (e.booking.id == 0) ? false : true,
						onLive: e.onLive,
						highlighted: e.highlighted,
						scoreboardType: 1,
						resultName: e.result.name,
						data: {
							infos: {
								stats: Stat
							},
							score: Score.score
						},
						startDate: e.startedAt,
						createdAt: e.createdAt,
						updatedAt: e.updatedAt,
						periodTime: e.periodTime,
						roundCounter: e.roundCounter,
						periodTimeLeft: e.periodTimeLeft,
						//odds: this.marketCompile(e),
						providerId: e.providerId,
						ts: e.ts,
						streamEmbed: e.streamEmbed,
						template: e.booking.template

					})

				// console.log(JSON.parse(e.stat))

				});


				return VirtualList;

				},
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.competition_head{
		border-bottom: 3px solid #73518e !important;
	}
	h1, h2 {
		font-weight: normal;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}

	a {
		color: #42b983;
	}
</style>



// WEBPACK FOOTER //
// src/components/stats/matches.vue